export default "__VITE_PUBLIC_ASSET__9923400c__"